export default __webpack_public_path__ + "static/media/QQT Demo with Nesting and CC.oggtheora.4730fb7c.ogv";